import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSteinbergComponent } from './simple-icons-steinberg.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSteinbergComponent ],
    exports:      [ SimpleIconsSteinbergComponent ],
    bootstrap:    []
})
export class SimpleIconsSteinbergModule {}
